
import { mapState } from 'vuex'
import commonImg from '~/components/common/commonImg.vue'
import wikiTextScroll from '~/components/common/wikiTextScroll.vue'
import sellDealer from '@/components/searchView/sellDealer.vue'
import Label from '~/components/common/Label.vue'
const _ = require('lodash')
export default {
  components: {
    'common-img': commonImg,
    'wiki-text-scroll': wikiTextScroll,
    'sell-dealer': sellDealer,
    Label
  },
  inject: ['keywordStr', 'tjdata'],
  props: {
    // 搜索统计
    isCollect: {
      type: Boolean,
      default: false
    },
    listData: {
      type: Array,
      default: () => []
    },
    typebool: {
      type: Boolean,
      default: true
    },
    cate: {
      type: String,
      default: ''
    },
    project: {
      type: Number,
      default: 2
    },
    type: {
      type: Number,
      default: 0
    }
  },
  data() {
    const _arrow = []
    const _list = _.cloneDeep(this.listData)
    _list.forEach((it) => {
      if (it) {
        _arrow.push({
          line2: false,
          show: false
        })
      }
    })
    return {
      directHistory: null,
      goBitCode: '',
      isShowBit: false,
      listArrow: _arrow
    }
  },
  computed: {
    ...mapState({
      lang: 'LanguageCode',
      mobile: 'mobile',
      country: (state) => state.getCountry.countryCode,
      userCode: (state) => (state.user.userId ? state.user.userId : '')
    })
  },
  mounted() {
    // console.log('listData', this.listData)
    // console.log('搜索页item', this.listArrow)
    // console.log('搜索页cate', this.cate)
    if (localStorage.getItem('directHistory')) {
      this.directHistory = JSON.parse(localStorage.getItem('directHistory'))
    }
    const that = this
    that.$nextTick(() => {
      if ((that.cate == 'trader' || that.cate == 'bit' || that.cate == 'prop') && that.listData && that.listData.length > 0) {
        const label = document.querySelectorAll('.laball' + (that.cate ? '_' + that.cate : ''))
        const arrow = document.querySelectorAll('.arrow_searchpage' + (that.cate ? '_' + that.cate : ''))
        if (label && label.length > 0) {
          const basewidth = document.querySelectorAll('.summarydesc')[0].offsetWidth
          label.forEach((info, k) => {
            // console.log('info.offsetHeight', info.offsetHeight)
            // info.classList.add('overhide')
            if (info.offsetHeight > 40) {
              info.classList.add('overhide')
              arrow[k].style.display = 'inline-block'
            } else {
              let curwidth = 0
              if (info.childNodes && info.childNodes.length > 0) {
                info.childNodes.forEach((it) => {
                  curwidth += it.offsetWidth
                })
              }
              if (curwidth > basewidth) {
                info.classList.add('overhide')
                arrow[k].style.display = 'inline-block'
              }
            }
            info.classList.add('overhide')
          })
        }
        // that.$forceUpdate()
      }
    })
  },
  methods: {
    changeItem(p = 1, c) {
      this.$emit('Echange', { project: p, code: c.code })
      if (this.isCollect) {
        this.postCollect(p, c)
      }
    },
    postCollect(p, c) {
      console.log('出发搜索统计', p, c, this.$route.query.keyword)
      const params = {
        // 创建时间
        CraeteTime: new Date().getTime(),
        // 来源渠道(1:Web,2:IOS,3:Android,4:小程序,5:H5,6:PC)
        channel: this.mobile ? 5 : 1,
        // 点击类型 bit(-1--全部,1--交易所,2--项目,3--钱包,4--通证)，wikifx(-1--全部,1--交易商,2--代理商,3--区块)
        clickListType: 1,
        // 受评方编码
        code: c.code,
        country: this.country,
        domain: document.domain,
        // 是否国际版
        isInternational: true,
        // 是否极简版
        isMinal: false,
        // 搜索关键字
        keyword: this.$route.query.keyword || '',
        // 语言
        language: this.lang,
        // 受评方名称
        name: c.englishShortName ? c.englishShortName : c.localShortName,
        // 1 bit App 2 bit Web
        paltform: 0,
        // 产品类型(1:FxEye,2:WikiFX,3:WikiBit,4:CnGold,5:waihui110)
        product: 2,
        // 项目类型 1 wikifx 2 wikibit
        project: 1,
        // 是否搜索,0-搜索提示提交，1-搜索结果页提交
        query: 1,
        // Project 为 1 => 1 交易商 2 代理商；Project 为2 => 1-交易所 2-项目 3-钱包 4-通证
        type: p,
        // 用户id
        uid: this.userCode
      }
      this.$api.search.collect(params).then((res) => {
        if (res && res.searchData) {
          // 提交成功
        }
      })
    },
    isHistory(c) {
      if (!this.directHistory) return false
      const codeArr = []
      this.directHistory.forEach((e) => {
        codeArr.push(e.code)
      })
      if (codeArr.includes(c)) return true
      return false
    },
    changeArrow(e, index) {
      const arrow = document.querySelectorAll('.laball' + (this.cate ? '_' + this.cate : ''))
      console.log(arrow[index], 111, index)
      if (this.listArrow && this.listArrow[index]) {
        this.listArrow[index].show = !this.listArrow[index].show
        console.log(this.listArrow[index].show, 4454)
        if (this.listArrow[index].show) {
          // arrow[index].classList.remove('overhide')
        } else {
          // arrow[index].classList.add('overhide')
        }
      }

      // e.stopPropagation()
      // this.$forceUpdate()
      // return false
    },
    Get4lab(labs) {
      if (labs && labs.length > 0) {
        return labs.slice(0, 4)
      }
      return labs
    },
    replaceKeyword(word) {
      const da = this.keywordStr.toUpperCase()
      const xiao = this.keywordStr.toLowerCase()
      if (word) {
        // 正向替换
        word = word.replace(this.keywordStr, `『${this.keywordStr}』`)
        word = da != this.keywordStr ? word.replace(da, `『${da}』`) : word
        word = xiao != this.keywordStr ? word.replace(xiao, `『${xiao}』`) : word
        // 反向还原
        word = word.replace(`『${this.keywordStr}』`, `<span style='color: #F15555;'>${this.keywordStr}</span>`)
        word = da != this.keywordStr ? word.replace(`『${da}』`, `<span style='color: #F15555;'>${da}</span>`) : word
        word = xiao != this.keywordStr ? word.replace(`『${xiao}』`, `<span style='color: #F15555;'>${xiao}</span>`) : word
      }
      return word
    }
  }
}
